<template>
  <div>
    <el-dialog :visible.sync="visible" width="40%" :close-on-click-modal="false" :append-to-body="true"
      @close="dialogClose">
      <div id='register'>
          <div class="registerbox">
            <div class="title">注册</div>
              <div>
                  <el-form :model="loginForm" @submit.native.prevent :rules="rules" ref="loginForm">
                      <div class="inputList">
                          <span class="roteSpan">姓名</span>
                          <div class="inputBox">
                              <img src="@/assets/image/login/username_before.png" alt="" v-if="loginForm.userName==''">
                              <img src="@/assets/image/login/username.png" alt="" v-else>
                              <el-form-item prop="userName">
                                  <el-input placeholder="请输入姓名" v-model="loginForm.userName" type="text"></el-input>
                              </el-form-item>
                          </div>
                      </div>
                      <div class="inputList">
                          <span class="roteSpan">手机号</span>
                          <div class="inputBox phone">
                              <el-select v-model="loginForm.region" placeholder="+86">
                                  <el-option label="+86" value="86" ></el-option>
                              </el-select>
                              <el-form-item prop="userTelephone">
                                <el-input placeholder="请输入手机号" v-model="loginForm.userTelephone" type="text"></el-input>
                              </el-form-item>
                          </div>
                      </div>
                      <div class="inputList">
                          <span class="roteSpan ">短信验证码</span>
                          <div class="inputBox yzm">
                              <img src="@/assets/image/login/yanzhengma_before.png" alt="" v-if="loginForm.verificationCode==''">
                              <img src="@/assets/image/login/yanzhengma.png" alt="" v-else>
                              <el-form-item prop="verificationCode">
                                  <el-input oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="验证码"
                                      v-model="loginForm.verificationCode" type="text"></el-input>
                              </el-form-item>

                          </div>
                          <el-button @click="yzm" v-bind:disabled="disabledYzm" class="btn">{{yzmText}}</el-button>

                      </div>
                      <div class="inputList">
                          <span class="roteSpan">密码</span>
                          <div class="inputBox">
                              <img src="@/assets/image/login/password_before.png" alt="" v-if="loginForm.passwordend==''">
                              <img src="@/assets/image/login/password.png" alt="" v-else>
                              <el-form-item prop="passwordend">
                                  <el-input maxlength="10" placeholder="设置密码" v-model="loginForm.passwordend"
                                      type="password"></el-input>
                              </el-form-item>

                          </div>
                      </div>
                      <div class="inputList">
                          <span class="roteSpan">确认密码</span>
                          <div class="inputBox">
                              <img src="@/assets/image/login/password_before.png" alt="" v-if="loginForm.password==''">
                              <img src="@/assets/image/login/password.png" alt="" v-else>
                              <el-form-item prop="password">
                                  <el-input maxlength="10" placeholder="确认密码" v-model="loginForm.password"
                                      type="password"></el-input>
                              </el-form-item>

                          </div>
                      </div>

                      <div class="btnBox">
                          <button @click="login">注册</button>
                      </div>
                        <div class="bottomTitle">
                          <el-checkbox v-model="checked"></el-checkbox>
                          <span>我已阅读并同意<span class="sp">《用户协议》</span>与<span class="sp">《隐私权政策》</span></span>
                        </div>
                  </el-form>

              </div>

          </div>
      </div>
      </el-dialog>
  </div>

</template>

<script>
    import md5 from 'js-md5';

    import { register,sendCode,userVerificationCode } from "../../api/login.js";
    export default {
      props: {
        dialogFormVisibleTwo: {
          type: Boolean,
          default: function() {
            return false
          }
        },
      },
        name: 'registers',
        data() {

            var validateMobile = (rule, value, callback) => {
                let regPone = null;
                let mobile = /^((13|14|15|17|18)[0-9]{1}\d{8})$/; // 最新16手机正则
                let tel = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/; // 座机
                if (value !== null && value.charAt(0) === "0") {
                    // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
                    regPone = tel;
                } else if (value !== null && value.charAt(0) !== "0") {
                    regPone = mobile;
                }
                if (regPone === null) {
                    this.isForbid = true;
                    return callback(new Error("请输入联系电话"));
                } else if (!regPone.test(value)) {
                    this.isForbid = true;
                    return callback(
                        new Error("请输入正确的电话格式")
                    );
                } else {
                    this.isForbid = false;
                    callback();
                }
            };
            var passWord = (rule, value, callback) => {
                let t = this
                console.log(value)
                if (value.length > 10) {
                    // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
                    return callback(new Error("限制为6-10位"));
                }
                if (value.length < 6) {
                    // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
                    return callback(new Error("限制为6-10位"));
                }
                if (value === null || value === '') {
                    return callback(new Error("请输入密码"));
                } else {
                    callback();
                }
            };
            var passWordends = (rule, value, callback) => {
                let t = this
                console.log(value, this.loginForm.passwordend)
                if (value !== this.loginForm.passwordend) {
                    return callback(new Error("请检查密码一致"));
                }
                if (value.length > 10) {
                    // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
                    return callback(new Error("限制为6-10位"));
                }
                if (value.length < 6) {
                    // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
                    return callback(new Error("限制为6-10位"));
                }
                if (value === null || value === '') {
                    return callback(new Error("请输入密码"));
                } else {
                    callback();
                }
            };
            return {
                rules: {
                    userTelephone: [
                        { required: true, validator: validateMobile, trigger: "blur" }
                    ],
                    userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                    passwordend: [{ required: true, validator: passWord, trigger: 'change' }],
                    password: [{ required: true, validator: passWordends, trigger: 'blur' }],
                    verificationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
                },
                isForbid: false,
                loginForm: {
                    userTelephone: '',
                    userName: '',
                    password: '',
                    verificationCode: '',
                    passwordend: ''
                },
                disabledYzm: false,
                yzmText: '获取验证码',
                level: [],
                passType1: 6,
                passType2: 6,
                visible:false,
                checked:true
            }
        },
        watch: {
            dialogFormVisibleTwo() {
              this.visible = this.dialogFormVisibleTwo;
            },
        },
        created() {
        },
        methods: {
          dialogClose() {
            this.$emit("update:dialogFormVisibleTwo", false);
            this.visible = false
          },
            async login() {

                this.$refs['loginForm'].validate((valid) => {
                    if (valid) {
                        if (this.loginForm.password !== this.loginForm.passwordend) {
                            this.$message.error('密码不一致');
                            return false
                        }
                        let query = `phone=${this.loginForm.userTelephone}&verificationCode=${this.loginForm.verificationCode}`
                        userVerificationCode(query).then(res => {
                           console.log(res)
                          if (res.code == 200) {
                            let password = md5(this.loginForm.password)
                            let data = {
                                userTelephone: this.loginForm.userTelephone,
                                userName: this.loginForm.userName,
                                password: password,
                                verificationCode: this.loginForm.verificationCode
                            }
                             register(data).then(res => {
                               console.log(res)
                              if (res.code == 200) {
                                this.$message({
                                    message: '注册成功',
                                    type: 'success'
                                });
                                this.$emit("update:dialogFormVisibleTwo", false);
                                this.visible = false
                              } else {
                                this.$message({
                                  type: "error",
                                  message: res.msg
                                });
                              }
                            });
                            console.log(this.loginForm)
                          } else {
                            this.$message({
                              type: "error",
                              message: res.msg
                            });
                          }
                        });

                    } else {

                        // console.log('error submit!!');
                        return false;
                    }
                });
                //
            },
            forgt() {
                this.$router.push('/forgotPassword')
            },
            smsAjaxFun() {
                this.yzmText = 60
                this.disabledYzm = true
                let time = setInterval(() => {
                    this.yzmText--
                    if (this.yzmText == 1) {
                        this.yzmText = '获取验证码'
                        clearInterval(time)
                        this.disabledYzm = false
                    }
                }, 1000)
            },
            yzm() {
              console.log(this.loginForm.userTelephone)
                let t = this
                let data = `phone=${t.loginForm.userTelephone}`
                sendCode(data).then(res => {
                    if (res.code == 200) {
                        t.$message({
                            message: '发送成功',
                            type: 'success'
                        });
                        t.smsAjaxFun()
                    } else {
                        t.$message.error(res.msg);
                    }
                });
            },
        }

    }
</script>

<style scoped>
    .registerTop {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 206px 0 100px;
        background: rgba(220, 236, 255, 0.5);
        box-shadow: 0px 0px 8px 0px rgba(183, 183, 183, 0.25);
    }
    .title {
      font-size: 36px;
      color: #000000;
      font-weight: 600;
      text-align: center;
      margin: 0 0 56px 30px;
    }
    .registerTop p {
        font-size: 16px;
        font-weight: 400;
        color: #000000;
    }

    .registerTop p span {
        color: rgba(1, 119, 251, 1);
        cursor: pointer;
    }

    .registerbox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 30px;
    }

    .registerboxHeade {
        display: flex;
        justify-content: center;
        text-align: center;
        margin-top: 36px;
        margin-bottom: 30px;
        margin-left: 40px;
    }

    .registerboxHeadeOne {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .registerboxHeadeOne span:nth-child(1) {
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        width: 40px;
        height: 40px;
        display: block;
        background: #0177FB;
        border-radius: 50%;
        line-height: 40px;
    }

    .registerboxHeadeOne span:nth-child(2) {
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        margin-top: 20px;
    }

    .registerboxHeadeLast {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .registerboxHeadeLast span:nth-child(1) {
        font-size: 16px;
        font-weight: 400;
        color: rgba(1, 119, 251, 1);
        width: 40px;
        height: 40px;
        display: block;
        border: 2px solid #0177FB;
        border-radius: 50%;
        line-height: 40px;
    }

    .registerboxHeadeLast span:nth-child(2) {
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        margin-top: 20px;
    }

    .registerboxHeadeLine {
        width: 400px;
        height: 2px;
        background: #E3E2E2;
        margin-top: 19px;
    }

    .inputList {
        width: 580px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        margin-bottom: 20px;
    }

    .inputList span {
        width: 110px;
        font-size: 17px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        text-align: right;
    }

    .inputBox {
        width: 448px;
        height: 45px;
        border: 1px solid #C6C6C6;
        border-radius: 5px;
        display: flex;
        align-items: center;
    }

    .inputBox img {
        width: 28px;
        height: 28px;
        margin-left: 16px;
    }

    >>>.el-input__inner {
        height: 40px;
        border: 0;
        font-size: 16px;
    }

    .phone>>>.el-input__inner {
        width: 350px;
    }

    .roteSpan::before {
        content: '*';
        font-size: 20px;
        color: rgba(255, 31, 31, 1);
    }

    .sex>>>.el-select {
        width: 100%;
        font-size: 18px;
    }

    .phone>>>.el-select {
        width: 80px;
    }

    .yzm {
        width: 236px;
    }

    >>>.el-input__inner::placeholder {
        font-size: 16px;
    }

    .btn {
        width: 192px;
        height: 45px;
        background: #fff;
        border: 1px solid #0177FB;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        border-radius: 5px;
        color: #0177FB;
    }

    .btnBox {
        width: 560px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-end;
        margin-top: 56px;
    }

    .btnBox button {
        width: 448px;
        height: 52px;
        background: #0177FB;
        font-size: 20px;
        font-weight: 400;
        color: #FFFFFF;
        border: 0;
        border-radius: 25px;
        cursor: pointer;
    }

    .btnBox span {
        font-size: 15px;
        font-weight: 400;
        color: #3A3A3A;
        margin-top: -20px;
        cursor: pointer;
    }

    .btnBox span:last-child {
        margin-left: 310px;
    }

    .registerboxHeadeLine .typeLginFalse {
        width: 50%;
        height: 100%;
        display: flex;
        background-color: rgba(1, 119, 251, 1);
    }

    .registerboxHeadeLine .typeLginTrue {
        width: 100%;
        height: 100%;
        display: flex;
        background-color: rgba(1, 119, 251, 1);
    }

    .loginTrue {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        margin-top: 100px;
    }

    .loginTrue p {
        font-size: 18px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #353535;
        margin-top: 56px;
    }

    .loginTrue p span {
        color: rgba(1, 119, 251, 1);
        cursor: pointer;
    }

    >>>.el-form-item {
        margin: 0;
        height: 38px;
        width: 100%;
    }

    /* >>>.el-form-item__error {
        top: 24%;
        left: 60%;
        word-break: keep-all;
    }

    .yzm>>>.el-form-item__error {
        top: 24%;
        left: 60%;
        word-break: keep-all;
    } */

    .qdBox {
        display: flex;
        align-items: center;
    }

    .color1 {
        width: 22px;
        height: 12px;
        background: #EAEAEA;
    }

    .qdBox div:nth-child(1) {
        border-radius: 12px 0px 0px 12px;
        margin-right: 1px;
    }

    .qdBox div:nth-child(3) {
        border-radius: 0 12px 12px 0;
        margin-left: 1px;
        margin-right: 15px;
    }

    .pass .inputBox {
        width: 310px;
    }

    .typeName {
        width: 10px;
    }

    .typeColor1 {
        background-color: rgba(253, 220, 146, 1);
    }

    .typeColor2 {

        background-color: rgba(183, 227, 160, 1);
    }

    .typeColor3 {

        background-color: rgba(105, 211, 55, 1);
    }

    .codeRight {
        width: 190px;
        display: flex;
        align-items: center;
    }

    .yzmList .code {
        width: 120px;
        height: 52px;
        background: #9C9C9C;
    }

    .codeRight span {
        width: 60px;
        font-size: 19px;
        font-weight: 400;
        color: #4D58F4;
        margin-left: 10px;
        cursor: pointer;
    }
    .bottomTitle {
      margin-top: 17px;
      color: #000000;
      text-align: center;
    }

    .bottomTitle .sp {
      color: #3065E4;
    }
    >>>.el-radio__label{
      font-size: 18px;
    }
    >>>.el-radio__inner{
      width: 30px;
      height: 30px;
    }
    >>>.el-radio__inner::after{
      width: 10px;
      height: 10px;
      background-color: #409EFF;
    }
    >>>.el-radio__input.is-checked .el-radio__inner{
      background-color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue